/**
 * Replaces nowrap{...} macro with inline HTML span element
 * @param {string} text - The text containing nowrap{...} macros
 * @returns {string} - The text with nowrap macros replaced by HTML spans
 */
export const applyNoWrapMacro = (text) => {
  if (typeof text !== 'string') return text;

  return text.replace(
    /nowrap\{([^}]*)\}/g,
    '<span class="nowrap">$1</span>'
  );
};
